import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";

export function useFetchCopayReportData(parameters,onFailureCallback) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "FetchCopayReportDataResult";

  async function GetCopayReportDataApiResult() {
    if(parameters == null) {
      return null;
    }
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get("api/CopayAdjustmentManager/DownloadCopayReport", {
        params: parameters,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (onFailureCallback) onFailureCallback(error);
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, parameters],
    queryFn: async () => await GetCopayReportDataApiResult(),
  });
}
